import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Contact } from 'app/types/types'

const initialState = {
  contactList: [] as Contact[],
  selectableContacts: [] as Contact[],
  selectedContacts: [] as Contact[],
  isContactNotSelected: false,
  isRoleNotSelected: false
}

const contactListSlice = createSlice({
  name: 'contactList',
  initialState,
  reducers: {
    initializeContactList: (
      state,
      action: PayloadAction<{ contactList: Contact[]; selectableContacts: Contact[]; selectedContacts: Contact[] }>
    ) => {
      state.contactList = action.payload.contactList
      state.selectableContacts = action.payload.selectableContacts
      state.selectedContacts = action.payload.selectedContacts
    },
    resetContactList: state => {
      state.contactList = state.selectedContacts
      state.isContactNotSelected = false
      state.isRoleNotSelected = false
    },
    addContact: state => {
      state.isContactNotSelected = false
      state.isRoleNotSelected = false
      state.contactList.unshift({} as Contact)
    },
    onContactSelectChange: (state, action: PayloadAction<{ index: number; contactId: string }>) => {
      const { index, contactId } = action.payload
      const currContact = state.selectableContacts.find(currentContact => currentContact.id === contactId)
      state.contactList[index] = { ...currContact!, role: '', contactRoleId: '' }
    },
    onRoleChange: (state, action: PayloadAction<{ index: number; role: string }>) => {
      const { index, role } = action.payload
      state.contactList[index] = { ...state.contactList[index], role }
    },
    deleteContact: (state, action: PayloadAction<number>) => {
      const index = action.payload
      const updatedContactList = [...state.contactList]
      updatedContactList.splice(index, 1)
      state.contactList = updatedContactList
    },
    setIsContactOrRoleNotSelected: (
      state,
      action: PayloadAction<{ isContactNotSelected: boolean; isRoleNotSelected: boolean }>
    ) => {
      const { isContactNotSelected, isRoleNotSelected } = action.payload
      state.isContactNotSelected = isContactNotSelected
      state.isRoleNotSelected = isRoleNotSelected
    }
  }
})

export const {
  initializeContactList,
  addContact,
  resetContactList,
  onContactSelectChange,
  onRoleChange,
  deleteContact,
  setIsContactOrRoleNotSelected
} = contactListSlice.actions
export default contactListSlice.reducer
